import { useState, useEffect } from 'react';
import api from '../services/api';
import axios from 'axios'; // TODO: rimuovere, usare api
import API_CONFIG from '../config/api';

const useNetworkHierarchy = (user) => {
  const [userNode, setUserNode] = useState(null);
  const [subordinateNodes, setSubordinateNodes] = useState([]);
  const [allNodes, setAllNodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Controllo più rigoroso: l'utente deve esistere e avere un ID valido
    if (!user || !user.id || user.id === undefined) {
      setLoading(false);
// console.log('❌ setUserNode: Reset a null (utente non valido)');
      setUserNode(null);
      setSubordinateNodes([]);
      setAllNodes([]);
      setError(null);
      return;
    }

    const fetchNetworkData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Usa l'endpoint corretto per ottenere la rete completa
        const response = await api.get(`/network/rete-corrente`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        
        if (response.data.success && response.data.data?.nodi) {
          const allNetworkNodes = response.data.data.nodi;
          setAllNodes(allNetworkNodes);
          
// console.log('🔍 DEBUG useNetworkHierarchy - Nodi ricevuti:', allNetworkNodes.length);
// console.log('🔍 DEBUG useNetworkHierarchy - User ID ricercato:', user.id, 'Type:', typeof user.id);
          
          // Debug: mostra tutti i nodi con i loro utenteId
          allNetworkNodes.forEach(node => {
// console.log(`🏢 Nodo ${node.id}: utenteId=${node.utenteId} (type: ${typeof node.utenteId}), nome=${node.nome}, tipo=${node.tipo}`);
          });
          
          // Trova il nodo dell'utente corrente
          const currentUserNode = allNetworkNodes.find(node => node.utenteId === user.id);
// console.log('🎯 Nodo trovato per utente:', currentUserNode ? `${currentUserNode.nome} (ID: ${currentUserNode.id})` : 'NESSUNO');

// console.log('✅ setUserNode: Settato nodo utente:', currentUserNode);
          setUserNode(currentUserNode);

          if (currentUserNode) {
            // Calcola i nodi subordinati ricorsivamente
            const subordinates = findSubordinateNodes(currentUserNode.id, allNetworkNodes);
            setSubordinateNodes(subordinates);
          } else {
            // L'utente non ha un nodo nella rete (es: admin)
            setSubordinateNodes([]);
          }
        } else {
          console.warn('Risposta API rete-corrente non valida:', response.data);
// console.log('❌ setUserNode: Reset a null (risposta non valida)');
          setUserNode(null);
          setSubordinateNodes([]);
          setAllNodes([]);
        }
      } catch (err) {
        console.error('Errore nel caricamento dei dati della rete:', err);
        setError(err.message);
// console.log('❌ setUserNode: Reset a null (errore catch)');
        setUserNode(null);
        setSubordinateNodes([]);
        setAllNodes([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNetworkData();
  }, [user?.id]);

  // Funzione per trovare ricorsivamente tutti i nodi subordinati
  const findSubordinateNodes = (parentId, nodes) => {
    const directChildren = nodes.filter(node => node.parentId === parentId);
    let allSubordinates = [...directChildren];
    
    // Ricorsivamente trova i figli dei figli
    directChildren.forEach(child => {
      const grandChildren = findSubordinateNodes(child.id, nodes);
      allSubordinates = allSubordinates.concat(grandChildren);
    });
    
    return allSubordinates;
  };

  // Funzione per verificare se l'utente può vedere un determinato nodo
  const canViewNode = (targetNodeId) => {
    const userRole = user?.role || user?.ruolo || '';
    
    // Admin possono vedere tutto sempre
    if (userRole === 'admin') return true;
    
    // Se l'utente non ha un nodo associato, non può vedere nulla (tranne admin)
    if (!userNode) return false;
    
    // Agenzia primaria può vedere tutto nella sua rete
    if (userRole === 'agenzia' && userNode.tipo === 'agenzia_primaria') return true;
    
    // Altri utenti possono vedere solo se stessi e i loro subordinati
    return targetNodeId === userNode.id || 
           subordinateNodes.some(node => node.id === targetNodeId);
  };

  // Funzione per ottenere gli ID dei nodi che l'utente può visualizzare
  const getVisibleNodeIds = () => {
    const userRole = user?.role || user?.ruolo || '';
    
    // Admin possono vedere tutti i nodi
    if (userRole === 'admin') {
      return allNodes.map(node => node.id);
    }
    
    // Se l'utente non ha un nodo associato, non può vedere nulla (tranne admin)
    if (!userNode) return [];
    
    // Agenzia primaria può vedere tutto nella sua rete
    if (userRole === 'agenzia' && userNode.tipo === 'agenzia_primaria') {
      return allNodes.map(node => node.id);
    }
    
    // Altri utenti vedono solo se stessi e i subordinati
    return [userNode.id, ...subordinateNodes.map(node => node.id)];
  };

  // Funzione per verificare se l'utente può gestire un determinato nodo
  const canManageNode = (targetNodeId) => {
    const userRole = user?.role || user?.ruolo || '';
    
    // Solo admin e agenzie primarie possono gestire altri nodi
    if (userRole === 'admin') return true;
    if (userRole === 'agenzia' && userNode && userNode.tipo === 'agenzia_primaria') return true;
    
    // Altri utenti non possono gestire nodi
    return false;
  };

  return {
    userNode,
    subordinateNodes,
    allNodes,
    loading,
    error,
    canViewNode,
    canManageNode,
    getVisibleNodeIds
  };
};

export default useNetworkHierarchy; 